import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { EmailWorkflowApi } from '../../services/emailWorkflowApi';
import { WorkflowDetailBody } from './WorkflowDetailBody';

/**
 * Page 2 — standalone Detail (deep-link / bookmark target).
 * Thin wrapper: header + back button around the shared <WorkflowDetailBody>.
 * The board shows the SAME body inside a slide-over — one source of truth.
 */
export const EmailWorkflowDetail: React.FC = () => {
	const { threadId = '' } = useParams();
	const navigate = useNavigate();
	const [title, setTitle] = useState<string>('Request');

	// just for the page heading — the body fetches its own full detail.
	useEffect(() => {
		let cancelled = false;
		EmailWorkflowApi.getDetail(threadId)
			.then(d => !cancelled && setTitle((d.state as any)?.counterparty || 'Request'))
			.catch(() => {});
		return () => {
			cancelled = true;
		};
	}, [threadId]);

	return (
		<div className="p-6 max-w-3xl">
			<button
				type="button"
				onClick={() => navigate('/email-workflows')}
				className="inline-flex items-center gap-1 text-sm text-gray-500 hover:text-gray-700 mb-4"
			>
				<ArrowLeft className="h-4 w-4" /> Back to board
			</button>
			<h1 className="text-xl font-semibold text-gray-900 mb-4">{title}</h1>
			<WorkflowDetailBody threadId={threadId} />
		</div>
	);
};

export default EmailWorkflowDetail;
